import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { VehicleLicensePlatePageRoutingModule } from './vehicle-license-plate-routing.module';

import { VehicleLicensePlatePage } from './vehicle-license-plate.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    VehicleLicensePlatePageRoutingModule,
    ComponentsModule,
  ],
  declarations: [VehicleLicensePlatePage],
})
export class VehicleLicensePlatePageModule {}
